import { render, staticRenderFns } from "./ConvertDuplicatesModal.vue?vue&type=template&id=36bafa75&"
import script from "./ConvertDuplicatesModal.vue?vue&type=script&lang=ts&"
export * from "./ConvertDuplicatesModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConvertDuplicatesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports